import React, { useContext, useEffect, useRef, useState } from 'react';
import {
    Row,
    Col,
    Card,
    CardBody,
    Button,
    CustomInput,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    FormGroup,
    Label,
    Input,
    Table,
    Pagination,
    PaginationItem,
    PaginationLink,
    UncontrolledButtonDropdown,
    Badge,
    InputGroup, InputGroupAddon
} from 'reactstrap';
import { AvForm, AvField, AvGroup, AvInput, AvFeedback } from 'availity-reactstrap-validation';
import { UserContext } from '../../contexts/UserContext';
import { SelectedFacilitiesContext } from '../../contexts/SelectedFacilitiesContext';
import { Icon } from '@iconify/react';
import roundDeleteForever from '@iconify/icons-ic/round-delete-forever';
import accountEditOutline from '@iconify/icons-mdi/account-edit-outline';
import accountEye from '@iconify/icons-mdi/account-eye';
import mdiAccountCogOutline from '@iconify/icons-mdi/account-cog-outline';
import dotsHorizontal from '@iconify/icons-mdi/dots-horizontal';
import Select from 'react-select';
import arrowsVertical from '@iconify/icons-carbon/arrows-vertical';
import arrowUp from '@iconify/icons-carbon/arrow-up';
import arrowDown from '@iconify/icons-carbon/arrow-down';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { SrxApi } from '../../api/SrxApi';
import officeBuildingOutline from '@iconify/icons-mdi/office-building-outline';
import lockReset from '@iconify/icons-mdi/lock-reset';
import MaskedInput from 'react-text-mask';
import { SelectedPharmaciesContext } from '../../contexts/SelectedPharmaciesContext';
import { UserRolesContext } from '../../contexts/UserRolesContext';
import cloneDeep from 'lodash.clonedeep';
import accountIcon from '@iconify/icons-mdi/account';
import shieldAccount from '@iconify/icons-mdi/shield-account';
import { confirm } from '../../utility-components/ConfirmModal';
import { Typeahead } from 'react-bootstrap-typeahead';
import deleteIcon from '@iconify/icons-mdi/delete';
import closeIcon from '@iconify/icons-mdi/close';
import Settings from '../UserSettings'
import { RoleBadgeList, createLimitedMultiValueContainer } from '../Users';

const PharmacyRoleValueContainer = createLimitedMultiValueContainer(2, 'pharmacy-role-select-chips');

const USER_ROLE_PERMISSION_KEY = {
    CustomerService: { add: 'canAddUserCustomerService', edit: 'canEditUserCustomerService', delete: 'canDeleteUserCustomerService' },
    FacilityAdmin: { add: 'canAddUserFacilityAdmin', edit: 'canEditUserFacilityAdmin', delete: 'canDeleteUserFacilityAdmin' },
    Manager: { add: 'canAddUserManager', edit: 'canEditUserManager', delete: 'canDeleteUserManager' },
    Staff: { add: 'canAddUserStaff', edit: 'canEditUserStaff', delete: 'canDeleteUserStaff' },
    SysAdmin: { add: 'canAddUserSysAdmin', edit: 'canEditUserSysAdmin', delete: 'canDeleteUserSysAdmin' },
    User: { add: 'canAddUserUser', edit: 'canEditUserUser', delete: 'canDeleteUserUser' },
    ViewOnly: { add: 'canAddUserViewOnly', edit: 'canEditUserViewOnly', delete: 'canDeleteUserViewOnly' },
    Pharmacist: { add: 'canAddUserPharmacist', edit: 'canEditUserPharmacist', delete: 'canDeleteUserPharmacist' },
};

const PharmacyUsers = () => {

    let history = useHistory();

    const { faciToken, setFaciToken, user } = useContext(UserContext);

    useEffect(() => {
        if (user?.userType !== 'PharmacyUser') {
            history.replace('/dashboard')
        }
    }, [user])

    const [users, setUsers] = useState([]);
    const [deletedUser, setDeletedUser] = useState(null);

    const [numberPharmacies, setNumberPharmacies] = useState(user.numberPharmacies);


    const [userFormModal, setUserFormModal] = useState({
        isOpen: false,
        mode: 'add',
        user: null,
        readOnly: false
    })

    const [entityId, setEntityId] = useState('');

    const [deleteUserModal, setDeleteUserModal] = useState({
        isOpen: false,
        data: ''
    });
    
    
    function closeDeleteUserModal() {
        setDeleteUserModal({
            isOpen: false,
            data: ''
        });
    }

    function closeUserFormModal() {
        setUserFormModal({
            isOpen: false,
            mode: 'add',
            user: null,
            readOnly: false
        })
    }


    const [editUserSettingsModal, setEditUserSettingsModal] = useState({
        isOpen: false,
        data: {
            user: null
        }
    });

    function closeEditUserSettingsModal() {
        setEditUserSettingsModal({
            isOpen: false,
            data: {
                user: null
            }
        });
    }

    const [searchTerm, setSearchTerm] = useState('');

    const [resetPasswordModal, setResetPasswordModal] = useState({
        isOpen: false,
        data: ''
    });

    const { pharmacies } = useContext(SelectedPharmaciesContext);

    function closePasswordModal() {
        setResetPasswordModal({
            isOpen: false,
            data: ''
        })
    }

    function getPharmacyUsers() {
        console.log("getPharmacyUsers function called");

        setUsers(null)
        SrxApi.get('/getpharmacyusers')
            .then(res => {
                setUsers(res.data.users)
                console.log("Updated users state:", res.data.users);
            })
            .catch(err => {
                setUsers([])
                toast.error('Error retrieving pharmacy users')
                if (err.response?.status === 401) {
                    localStorage.removeItem('FACI_TOKEN');
                    setFaciToken(null);
                    history.replace('/account/login')
                }
            })
    }

    useEffect(() => {
        console.log("useEffect is running");
        getPharmacyUsers()
    }, [])


    function searchUsers(array) {
        if (searchTerm) {
            let results = array.filter(user => (user.displayName && user.displayName.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase())) || user.email.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase()));
            return results
        } else {
            return array
        }
    }

    const [sortBy, setSortBy] = useState({
        sortField: 'displayName',
        sortDirection: 'asc'
    })

    function sortByField(array) {
        switch (sortBy.sortField) {
            case 'email':
                if (sortBy.sortDirection === 'asc')
                    return array.sort((a, b) => a.email < b.email ? -1 : 1)
                else
                    return array.sort((a, b) => a.email > b.email ? -1 : 1)
            case 'displayName':
                if (sortBy.sortDirection === 'asc')
                    return array.sort((a, b) => a.displayName < b.displayName ? -1 : 1)
                else
                    return array.sort((a, b) => a.displayName > b.displayName ? -1 : 1)
        }
    }

    function onClickSort(field) {
        if (field === sortBy.sortField) {
            setSortBy({
                ...sortBy,
                sortDirection: sortBy.sortDirection === 'asc' ? 'desc' : 'asc'
            })
        } else {
            setSortBy({
                sortField: field,
                sortDirection: 'asc'
            })
        }
    }

    const SortCarets = () => (
        <>
            {sortBy.sortDirection === 'asc' ?
                <Icon icon={arrowUp} color="black" />
                :
                <Icon icon={arrowDown} color="black" />
            }
        </>
    )

    function formatPhoneNumber(phoneNumberString) {
        var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
        var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            var intlCode = (match[1] ? '+1 ' : '');
            return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
        }
        return null;
    }

    const canResetPassword = (user_) => {
        // console.log(users)
        // console.log(user_);
        let signedInUser = users?.find(u => u.email === user.email); //returns signed in user
        if (!signedInUser) {
            // console.log("User not found");
            return false;
        }
        let signedInUserRoles = signedInUser?.pharmRole || []; //returns pharmRole array/s of signed in user
        let selectedUserRoles = user_?.pharmRole || []; //returns pharmRole array/s of selected user
        function findMatchingPharid(signedInUserRoles, selectedUserRoles) {
            let matchingPharid = [];
            // Loop through the pharmRole array of the first user
            for (const role1 of signedInUserRoles) {
                const pharid1 = role1.pharid;

                for (const role2 of selectedUserRoles) {
                    const pharid2 = role2.pharid;

                    if (pharid1 === pharid2) {
                        matchingPharid.push(pharid1);
                    }
                }
            }

            return matchingPharid;

        }
        let hasMatchingPharid = findMatchingPharid(signedInUserRoles, selectedUserRoles) // returns common pharid of both users
        if (hasMatchingPharid.length === 0) {
            // console.log("No matching pharid found.");
            return false;
        }
        let matchingPharmacy = pharmacies?.filter((pharmacy) => hasMatchingPharid.includes(pharmacy.pharmID)); //returns common pharmacies!
        let selectedUserRole = [...new Set(user_?.pharmRole?.map(r => r.role))]; //returns selected user role/s without duplicates
        let permissionRole = selectedUserRole.map(role => USER_ROLE_PERMISSION_KEY[role]?.edit).filter(Boolean);
        let allUserPermissions = matchingPharmacy.map((pharmacy) => pharmacy.userPermissions); //returns all user permissions
        // Allowed if, on any shared pharmacy, the signed-in user is actually granted edit on any of the selected user's roles.
        return permissionRole.some((key) => allUserPermissions.some((permissions) => permissions?.[key] === true));
    }

    const canAddPharmacy = (user_) => {
        let signedInUser = users?.find(u => u.email === user.email);
        if (!signedInUser) return false;

        let signedInUserRoles = signedInUser?.pharmRole || [];
        let selectedUserRoles = user_?.pharmRole || [];
        function findMatchingPharid(signedInUserRoles, selectedUserRoles) {
            let matchingPharid = [];
            for (const role1 of signedInUserRoles) {
                const pharid1 = role1.pharid;
                for (const role2 of selectedUserRoles) {
                    const pharid2 = role2.pharid;
                    if (pharid1 === pharid2) matchingPharid.push(pharid1);
                }
            }
            return matchingPharid;
        }
        let hasMatchingPharid = findMatchingPharid(signedInUserRoles, selectedUserRoles);
        if (hasMatchingPharid.length === 0) return false;

        let matchingPharmacy = pharmacies?.filter((pharmacy) => hasMatchingPharid.includes(pharmacy.pharmID));
        let allUserPermissions = matchingPharmacy.map((pharmacy) => pharmacy.userPermissions);
        return allUserPermissions.some((permissions) => permissions?.canAddPharmacyToUser === true);
    }

    const canDelete = (user_) => {
        console.log(users)
        console.log(user_);
        let signedInUser = users?.find(u => u.email === user.email); //returns signed in user
        if (!signedInUser) {
            console.log("User not found");
            return false;
        }
        let signedInUserRoles = signedInUser?.pharmRole || []; //returns pharmRole array/s of signed in user
        let selectedUserRoles = user_?.pharmRole || []; //returns pharmRole array/s of selected user
        function findMatchingPharid(signedInUserRoles, selectedUserRoles) {
            let matchingPharid = [];
            // Loop through the pharmRole array of the first user
            for (const role1 of signedInUserRoles) {
                const pharid1 = role1.pharid;

                for (const role2 of selectedUserRoles) {
                    const pharid2 = role2.pharid;

                    if (pharid1 === pharid2) {
                        matchingPharid.push(pharid1);
                    }
                }
            }

            return matchingPharid;

        }
        let hasMatchingPharid = findMatchingPharid(signedInUserRoles, selectedUserRoles) // returns common pharid of both users
        if (hasMatchingPharid.length === 0) {
            console.log("No matching pharid found.");
            return false;
        }
        let matchingPharmacy = pharmacies?.filter((pharmacy) => hasMatchingPharid.includes(pharmacy.pharmID)); //returns common pharmacies!
        let selectedUserRole = [...new Set(user_?.pharmRole?.map(r => r.role))]; //returns selected user role/s without duplicates
        let permissionRole = selectedUserRole.map(role => USER_ROLE_PERMISSION_KEY[role]?.delete).filter(Boolean);
        let allUserPermissions = matchingPharmacy.map((pharmacy) => pharmacy.userPermissions); //returns all user permissions
        // Allowed if, on any shared pharmacy, the signed-in user is actually granted delete on any of the selected user's roles.
        return permissionRole.some((key) => allUserPermissions.some((permissions) => permissions?.[key] === true));
    }

    const canChangeUserSettings = (user_) => {
        let thePermission = 'canSetSettingsForUsers'
        let signedInUser = users?.find(u => u.email === user.email); //returns signed in user

        let signedInUserRoles = signedInUser?.pharmRole || []; //returns pharmRole array/s of signed in user
        let selectedUserRoles = user_?.pharmRole || []; //returns pharmRole array/s of selected user

        function findMatchingPharid(signedInUserRoles, selectedUserRoles) {
            let matchingPharid = [];
            // Loop through the pharmRole array of the first user
            for (const role1 of signedInUserRoles) {
                const pharid1 = role1.pharid;

                for (const role2 of selectedUserRoles) {
                    const pharid2 = role2.pharid;

                    if (pharid1 === pharid2) {
                        matchingPharid.push(pharid1);
                    }
                }
            }
            return matchingPharid;
        }
        let hasMatchingPharid = findMatchingPharid(signedInUserRoles, selectedUserRoles) // returns common pharid of both users
        if (hasMatchingPharid.length === 0) {
            return false;
        }
        let matchingPharmacy = pharmacies?.filter((pharmacy) => hasMatchingPharid.includes(pharmacy.pharmID)); //returns common pharmacies!
        return (matchingPharmacy[0]?.userPermissions?.[thePermission])
    }

    const canEditRole = (pharmID, roles, action) => {
        let commonPharmID = pharmacies?.find(p => p.pharmID === pharmID)
        if (!commonPharmID) return false;

        let permissions = commonPharmID.userPermissions;
        let roleList = Array.isArray(roles) ? roles : roles ? [roles] : [];

        return roleList.some((roleName) => {
            let permissionKey = action === 'delete' ? USER_ROLE_PERMISSION_KEY[roleName]?.delete : USER_ROLE_PERMISSION_KEY[roleName]?.edit;
            return !!permissionKey && permissions?.[permissionKey] === true;
        });
    }
    console.log(user)

    if (!users)
        return (
            <div className='page-loading-loader-div w-100 d-flex justify-content-center align-items-center'>
                <div>
                    <h4>Loading Pharmacy Users...</h4>
                    <div className="bouncing-loader">
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </div>
        )

    return (
        <>
            <div className='mt-3 mx-2'>
                <h2>Pharmacy Users</h2>
                <Card>
                    <CardBody>
                        {/* <h4 className="header-title">Product List</h4>
                <p className="text-muted font-14 mb-4">A list of all existing Greenbowl Products</p> */}
                        <Row className="mb-2 d-flex justify-content-between">
                            <Col xs={'auto'}>
                                <Button color='primary'
                                    onClick={() => {
                                        setUserFormModal({ isOpen: true, mode: 'add', user: null })
                                    }}
                                >
                                    <i className="mdi mdi-plus-circle mr-2"></i>Add Pharmacy User
                                </Button>
                            </Col>
                            <Col className="text-right" md={5}>
                                <FormGroup className='d-flex mb-0 align-items-center' style={{ overflow: 'hidden', whiteSpace: 'nowrap' }}>
                                    <Label className='mr-2 mb-0'><b>Search:</b></Label>
                                    <Input value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}>
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Table className="mb-0">
                            <thead className="bg-light">
                                <tr>
                                    <th onClick={() => onClickSort('displayName')} className="th-hover">Name {sortBy.sortField === 'displayName' ? <SortCarets /> : <Icon icon={arrowsVertical} style={{ opacity: '0.6' }} />}</th>
                                    <th onClick={() => onClickSort('email')} className="th-hover">Email {sortBy.sortField === 'email' ? <SortCarets /> : <Icon icon={arrowsVertical} style={{ opacity: '0.6' }} />}</th>
                                    <th>Phone</th>
                                    <th>Pharmacies</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {sortByField(searchUsers(users))
                                    .map((user_, index) => {
                                        return (
                                            <tr key={index} >
                                                <th scope="row" style={{ verticalAlign: 'middle' }}>{user_.displayName}{(user_.email === user.email) && <Badge color="dark" className='ml-1' style={{ fontSize: '12px' }}>Self</Badge>}</th>
                                                <td style={{ verticalAlign: 'middle' }}>{user_.email}</td>
                                                <td style={{ verticalAlign: 'middle' }}>{formatPhoneNumber(user_.phone)}</td>
                                                {/* <td style={{ verticalAlign: 'middle' }}><b><i>{[...new Set(user_.roles)] ? [...new Set(user_.roles)][0] : ''}</i></b></td> */}
                                                <td style={{ verticalAlign: 'middle' }} className="position-relative">
                                                    <b>{user_.numberPharmacies}</b>
                                                </td>
                                                <td className='position-relative'>
                                                    <UncontrolledButtonDropdown className="position-absolute" style={{ right: '20px', top: '5px', cursor: 'pointer' }}>
                                                        <DropdownToggle tag="button" className="btn btn-lg btn-link no-arrow card-drop p-0">
                                                            <Icon icon={dotsHorizontal} width="23" height="23" />
                                                        </DropdownToggle>
                                                        <DropdownMenu right style={{ minWidth: 'max-content' }}>
                                                            {/* <DropdownItem className='px-3 py-1'
                                            ><Icon icon={accountDetails} width="20" height="20" className="mr-1"/>Edit Details</DropdownItem> */}
                                                            {(() => {
                                                                const canEditUser = canResetPassword(user_) || canAddPharmacy(user_);
                                                                return (
                                                                    <DropdownItem className='px-3 py-1'
                                                                        onClick={() => setUserFormModal({
                                                                            isOpen: true,
                                                                            mode: 'update',
                                                                            user: user_,
                                                                            readOnly: !canEditUser
                                                                        })}
                                                                    ><Icon icon={canEditUser ? accountEditOutline : accountEye} width="20" height="20" className="mr-1" />{canEditUser ? 'Update User' : 'View Pharmacies'}</DropdownItem>
                                                                );
                                                            })()}
                                                            {canResetPassword(user_) &&
                                                                <DropdownItem className='px-3 py-1'
                                                                    //    disabled={canResetPassword(user_)}
                                                                    onClick={() => setResetPasswordModal({
                                                                        isOpen: true,
                                                                        data: user_

                                                                    })}
                                                                ><Icon icon={lockReset} width="20" height="20" className="mr-1" />Reset Password</DropdownItem>

                                                            }
                                                            {canChangeUserSettings(user_) &&
                                                                <DropdownItem className='px-3 py-1'
                                                                    onClick={() => setEditUserSettingsModal({
                                                                        isOpen: true,
                                                                        data: user_

                                                                    })}
                                                                ><Icon icon={mdiAccountCogOutline} width="20" height="20" className="mr-1" />Edit User Settings</DropdownItem>

                                                            }
                                                            {canDelete(user_) && 
                                                                        <DropdownItem className='px-3 py-1'
                                                                            onClick={() => setDeleteUserModal({
                                                                                isOpen: true,
                                                                                data: user_
                                                                            })}
                                                                        ><Icon icon={roundDeleteForever} width="20" height="20" className="mr-1" />Delete User</DropdownItem>
                                                                    }
                                                        </DropdownMenu>
                                                    </UncontrolledButtonDropdown>
                                                </td>
                                            </tr>
                                        );
                                    })}
                            </tbody>
                        </Table>
                    </CardBody>
                </Card>
                <UserFormModal isOpen={userFormModal.isOpen} mode={userFormModal.mode} user={userFormModal.user} readOnly={userFormModal.readOnly} toggle={closeUserFormModal}
                    setFaciToken={setFaciToken} users={users} setUsers={setUsers} contextUser={user} canEditRole={canEditRole}
                    getPharmacyUsers={getPharmacyUsers}
                />
                <ResetPasswordModal isOpen={resetPasswordModal.isOpen} toggle={closePasswordModal} user={resetPasswordModal.data} entityId={entityId} />

                <EditUserSettingsModal isOpen={editUserSettingsModal.isOpen} toggle={closeEditUserSettingsModal} user={editUserSettingsModal.data} entityId={entityId} setFaciToken={setFaciToken} users={users} setUsers={setUsers} contextUser={user} />
                <DeleteUserModal isOpen={deleteUserModal.isOpen} toggle={closeDeleteUserModal} user={deleteUserModal.data} entityId={entityId} users={users} setUsers={setUsers} contextUser={user} deleteUserModal={deleteUserModal} setDeleteUserModal={setDeleteUserModal} closeDeleteUserModal={closeDeleteUserModal} deletedUser={deletedUser} setDeletedUser={setDeletedUser}/>
            </div>
        </>
    );
};

const DeleteUserModal = ({ isOpen, toggle, user, entityId, users, setUsers, contextUser, deletedUser, setDeletedUser, setDeleteUserModal}) => {
    const deleteUser = (deletedUser) => {
        console.log(deletedUser)
        const payload = {
          email: deletedUser.email,
          entityId: deletedUser.pharmRole[0].pharid,
          UserId: deletedUser.userId,
        };
      
        SrxApi.post('/deleteuser', payload)
          .then((res) => {
            const updatedUsers = users.filter((user) => user.email !== deletedUser.email);
            setUsers(updatedUsers);
            setDeletedUser(deletedUser); // Store the deleted user for potential undo
            SrxApi.get('/getpharmacyusers')
              .then((res) => {
                setUsers(res.data.users);
              })
              .catch((err) => {
                toast.error('Error retrieving user list');
              });
            setDeleteUserModal({ isOpen: false, data: '' });
            // setDeletedUser(null);
            toggle();
            console.log(deletedUser)
            toast.success(`${deletedUser.displayName || deletedUser.email} deleted successfully`);
          })
          .catch((err) => {
            toast.error('Error deleting user: ' + err.message);
          });
      };

      const [userPharmacies, setUserPharmacies] = useState(null);
        useEffect(() => {
            if (isOpen) {
                setUserPharmacies([]);
                SrxApi.get('/userpharmacies', {
                    params: {
                        email: user.email
                    }
                })
                    .then(({ data }) => setUserPharmacies(data.pharmacies))
                    .catch(err => {
                        toast.error('Error: ' + err.message)
                    })
            }
        }, [isOpen, user?.email])
      
return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle} className="modal-colored-header bg-primary">
        Delete User
      </ModalHeader>
      <ModalBody>
        <h5>Are you sure you want to delete <b>{user.displayName}</b>?</h5>
        {userPharmacies && (
        <table>
            <thead>
            <tr>
                {userPharmacies.length > 0 && <th>Pharmacies</th>}
                {/* <th >Pharmacy ID</th>
                <th>Pharmacy Name</th> */}
            </tr>
            </thead>
            <tbody>
            {userPharmacies
                .sort((a, b) => (a.pharmName > b.pharmName ? 1 : -1))
                .map((pharmacies, index) => (
                <tr key={index}>
                    <td style={{ verticalAlign: 'middle', fontWeight: 'bold' }}>{pharmacies.pharmacyId}</td>
                    <td style={{ verticalAlign: 'middle', fontWeight: 'normal' }}>{pharmacies.pharmName}</td>
                </tr>
                ))
            }
            </tbody>
        </table>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={() => deleteUser(user)}>Delete</Button>
        <Button color="secondary" onClick={toggle}>Cancel</Button>
      </ModalFooter>
    </Modal>
);
};
const EditUserSettingsModal = ({ isOpen, toggle, user, users, setUsers, contextUser, }) => {

    const handleSave = () => {
        console.log('saving...');
    }

    return (
        <Modal isOpen={isOpen} toggle={toggle} style={{ minWidth: '800px' }}>
            <ModalHeader toggle={toggle} className="modal-colored-header bg-primary">Edit settings for <i>"{user.displayName}"</i></ModalHeader>
            <ModalBody>

                <Settings userData={user} toggle={toggle} users={users} setUsers={setUsers} />
            </ModalBody>
            {/* <ModalFooter>
                <Button color="primary" onClick={handleSave}>
                    Save
                </Button>
                <Button color="secondary" onClick={toggle}>
                    Cancel
                </Button>
            </ModalFooter> */}
        </Modal>
    );
};


const ResetPasswordModal = ({ isOpen, toggle, user }) => {
    console.log(user)

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    function handleValidSubmit() {
        if (password !== confirmPassword)
            return toast.error('Passwords do not match')

        let resetPasswordPayload = {
            password,
            confirmPassword,
            email: user.email,
            entityId: user.pharmRole[0].pharid
        }



        SrxApi.post('/adminpwdreset', resetPasswordPayload)
            .then(res => {
                toast.success(res.data.message + ' for ' + '"' + res.data.email + '"')
                toggle()
            })
            .catch(err => toast.error(err.message))
    }

    useEffect(() => {
        if (!isOpen) {
            setPassword('');
            setConfirmPassword('');
        }
    }, [isOpen])

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle} className="modal-colored-header bg-primary">
                Reset Password for <i>"{user.displayName}"</i>
            </ModalHeader>
            <ModalBody>
                <AvForm onValidSubmit={() => handleValidSubmit()}>

                    <AvGroup>
                        <Label for="password">New Password</Label>
                        <AvField
                            type="password"
                            name="password"
                            id="password"
                            placeholder="Enter new password"
                            onChange={(e) => setPassword(e.target.value)}
                            value={password}
                            required
                            validate={{
                                minLength: { value: 4, errorMessage: 'Password must include a minimum of 4 characters' }
                            }}
                        />
                    </AvGroup>

                    <AvGroup>
                        <Label for="confirm-password">Confirm New Password</Label>
                        <AvField
                            type="password"
                            name="confirm-password"
                            id="confirm-password"
                            placeholder="Confirm new password"
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            value={confirmPassword}
                            required
                            validate={{
                                minLength: { value: 4, errorMessage: 'Password must include a minimum of 4 characters' }
                            }}
                        />
                        {/* <AvFeedback>This field is invalid</AvFeedback> */}
                    </AvGroup>

                    <FormGroup>
                        <Button color="secondary">Reset Password</Button>
                    </FormGroup>
                </AvForm>
            </ModalBody>
        </Modal>
    )
};

const UserFormModal = ({ isOpen, toggle, mode, user, readOnly = false, setFaciToken, users, setUsers, contextUser, canEditRole, getPharmacyUsers }) => {
    const { pharmacies } = useContext(SelectedPharmaciesContext);
    const { pharmacyUserRoles, refetchUserRoles } = useContext(UserRolesContext);
    let history = useHistory();

    const isUpdateMode = mode === 'update';

    const [email, setEmail] = useState('');
    const [lookupStatus, setLookupStatus] = useState('idle');
    const [lookupUser, setLookupUser] = useState(null);
    const [isDeletedUser, setIsDeletedUser] = useState(false);

    const [displayName, setDisplayName] = useState('');
    const [phone, setPhone] = useState('');
    const [title, setTitle] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [saving, setSaving] = useState(false);

    const [validState, setValidState] = useState({
        displayName: true,
        phone: true,
        password: true,
        confirmPasswordMatches: true,
        pharmacies: true,
        pharmacyRoleOrTemplate: true,
    });

    const [newUserPharmacies, setNewUserPharmacies] = useState([]);
    const [newUserTemplateRole, setNewUserTemplateRole] = useState(null);
    const [newUserPharmacyRole, setNewUserPharmacyRole] = useState(null);

    const [userPharmacies, setUserPharmacies] = useState(null);
    const [pendingUserPharmacies, setPendingUserPharmacies] = useState([]);
    const [selectedPharmacy, setSelectedPharmacy] = useState([]);
    const [roleTemplates, setRoleTemplates] = useState([]);
    const [selectedRoleTemplates, setSelectedRoleTemplates] = useState({});
    const [standardUserRoles, setStandardUserRoles] = useState(null);
    const [selectedStandardRole, setSelectedStandardRole] = useState(null);
    const [standardRoleChipHovered, setStandardRoleChipHovered] = useState(false);
    const [pharmacyRoleOverrides, setPharmacyRoleOverrides] = useState({});
    const [initialUserDetails, setInitialUserDetails] = useState({ displayName: '', phone: '', title: '' });
    const [hasPerformedAction, setHasPerformedAction] = useState(false);
    const [pendingBulkTemplate, setPendingBulkTemplate] = useState(null);
    const [pendingBulkRole, setPendingBulkRole] = useState(null);
    const [savedPharmaciesRoleGroup, setSavedPharmaciesRoleGroup] = useState(null);

    const activeUser = isUpdateMode ? user : lookupUser;
    const isKnownUser = isUpdateMode || lookupStatus === 'found';
    const showDetailFields = isUpdateMode || lookupStatus === 'found' || lookupStatus === 'not-found';

    const isDetailsUnchanged =
        isKnownUser &&
        displayName === initialUserDetails.displayName &&
        phone === initialUserDetails.phone &&
        title === initialUserDetails.title;

    function canAddPharmacy(user_) {
        let signedInUser = users?.find((u) => u.email === contextUser.email);
        if (!signedInUser) return true;
        let signedInUserRoles = signedInUser?.pharmRole || [];
        let selectedUserRoles = user_?.pharmRole || [];
        let hasMatchingPharid = signedInUserRoles.filter((r1) => selectedUserRoles.some((r2) => r2.pharid === r1.pharid));
        if (hasMatchingPharid.length === 0) return true;

        let matchingPharmacy = pharmacies?.filter((p) => hasMatchingPharid.some((m) => m.pharid === p.pharmID));
        let allUserPermissions = matchingPharmacy.map((p) => p.userPermissions);
        return allUserPermissions.some((permissions) => permissions?.canAddPharmacyToUser === true);
    }

    const canManageFacilities = !readOnly && (isKnownUser ? canAddPharmacy(activeUser) : true);

    useEffect(() => {
        if (!isOpen) return;

        refetchUserRoles && refetchUserRoles();

        SrxApi.get('/roletemplates', { params: { entity: 'pharmacy' } })
            .then((res) => {
                const templates = res.data?.roleTemplates || res.data || [];
                setRoleTemplates(
                    templates.map((template) => ({
                        value: template.roleTemplateId,
                        label: template.templateName,
                        userRoles: template.userRoles || [],
                    }))
                );
            })
            .catch(() => setRoleTemplates([]));

        SrxApi.get('/roles', { params: { entity: 'standardUser' } })
            .then((res) => setStandardUserRoles(res.data?.roles || []))
            .catch(() => setStandardUserRoles([]));
    }, [isOpen]);

    function loadUserPharmacies(forEmail) {
        setUserPharmacies([]);
        SrxApi.get('/userpharmacies', { params: { email: forEmail } })
            .then(({ data }) => {
                setUserPharmacies(data.pharmacies);
                const existingStandardRole = data.pharmacies?.find((p) => p.standardRoles?.length)?.standardRoles?.[0];
                setSelectedStandardRole(existingStandardRole ? { value: existingStandardRole, label: existingStandardRole } : null);
            })
            .catch((err) => {
                if (err.response?.status === 401) {
                    localStorage.removeItem('FACI_TOKEN');
                    setFaciToken(null);
                    history.replace('/account/login');
                }
            });
    }

    useEffect(() => {
        if (!userPharmacies?.length || !roleTemplates.length) return;
        const templateIds = new Set(userPharmacies.map((p) => p.roleTemplate?.roleTemplateId).filter((id) => id != null));
        if (templateIds.size === 1) {
            const [templateId] = templateIds;
            const matchedTemplate = roleTemplates.find((t) => t.value === templateId);
            if (matchedTemplate) setSavedPharmaciesRoleGroup(matchedTemplate);
        }
    }, [userPharmacies, roleTemplates]);

    useEffect(() => {
        if (!isOpen) return;

        setPharmacyRoleOverrides({});
        setSelectedRoleTemplates({});
        setSelectedStandardRole(null);
        setPendingUserPharmacies([]);
        setSelectedPharmacy([]);
        setNewUserPharmacies([]);
        setNewUserTemplateRole(null);
        setNewUserPharmacyRole(null);
        setHasPerformedAction(false);
        setPendingBulkTemplate(null);
        setSavedPharmaciesRoleGroup(null);
        setValidState({
            displayName: true,
            phone: true,
            password: true,
            confirmPasswordMatches: true,
            pharmacies: true,
            pharmacyRoleOrTemplate: true,
        });
        setPassword('');
        setConfirmPassword('');

        if (isUpdateMode) {
            setEmail(user?.email || '');
            setDisplayName(user?.displayName || '');
            setPhone(user?.phone || '');
            setTitle(user?.title || '');
            setInitialUserDetails({
                displayName: user?.displayName || '',
                phone: user?.phone || '',
                title: user?.title || '',
            });
            setLookupStatus('found');
            setLookupUser(null);
            setIsDeletedUser(false);
            loadUserPharmacies(user?.email);
        } else {
            setEmail('');
            setDisplayName('');
            setPhone('');
            setTitle('');
            setInitialUserDetails({ displayName: '', phone: '', title: '' });
            setLookupStatus('idle');
            setLookupUser(null);
            setIsDeletedUser(false);
            setUserPharmacies(null);
        }
    }, [isOpen, user]);

    const emailDebounceRef = useRef(null);

    function handleEmailChange(value) {
        setEmail(value);

        if (emailDebounceRef.current) clearTimeout(emailDebounceRef.current);

        if (!value || !/\S+@\S+\.\S+/.test(value)) {
            setLookupStatus('idle');
            setLookupUser(null);
            setIsDeletedUser(false);
            setUserPharmacies(null);
            return;
        }

        if (!value.toLowerCase().endsWith('@srxltc.com')) {
            setLookupStatus('invalid-domain');
            setLookupUser(null);
            setIsDeletedUser(false);
            setUserPharmacies(null);
            return;
        }

        emailDebounceRef.current = setTimeout(() => runEmailLookup(value), 500);
    }

    function runEmailLookup(value) {
        setLookupStatus('loading');
        SrxApi.get('/userlookup', { params: { email: value } })
            .then(({ data }) => {
                if (data?.exists) {
                    setLookupUser(data);
                    setIsDeletedUser(!!data.isDeleted);
                    setLookupStatus('found');
                    setDisplayName(data.displayName || '');
                    setPhone(data.phone || '');
                    setTitle(data.title || '');
                    setInitialUserDetails({
                        displayName: data.displayName || '',
                        phone: data.phone || '',
                        title: data.title || '',
                    });
                    loadUserPharmacies(value);
                } else {
                    setLookupUser(null);
                    setIsDeletedUser(false);
                    setLookupStatus('not-found');
                    setDisplayName('');
                    setPhone('');
                    setTitle('');
                    setUserPharmacies([]);
                }
            })
            .catch(() => {
                setLookupStatus('not-found');
                setLookupUser(null);
                setIsDeletedUser(false);
                setUserPharmacies([]);
            });
    }

    function onPharmRoleTemplateChange(roleTemplateId, forEmail, pharmacy) {
        SrxApi.post('/edituser', { entityID: pharmacy.pharmacyId, email: forEmail, RoleTemplateId: roleTemplateId })
            .then(() => toast.success('User role successfully changed'))
            .catch((err) => toast.error('Error: ' + err.message));
    }

    function removeRoleGroupFromAllPharmacies(roleGroup) {
        const templateRoles = roleGroup?.userRoles || [];
        setSavedPharmaciesRoleGroup(null);

        if (!templateRoles.length) return;

        const editablePharmacies = getEditablePharmacies().filter((pharm) =>
            templateRoles.some((role) => getPharmacyRoleDisplay(pharm).displayedRoles.includes(role))
        );

        if (!editablePharmacies.length) return;

        setHasPerformedAction(true);

        editablePharmacies.forEach((pharm) => {
            const id = getPharmacyId(pharm);
            const { displayedRoles } = getPharmacyRoleDisplay(pharm);
            setPharmacyRoleOverrides((prev) => ({
                ...prev,
                [id]: (prev[id] ?? displayedRoles).filter((r) => !templateRoles.includes(r)),
            }));
        });

        Promise.all(
            editablePharmacies.flatMap((pharm) =>
                templateRoles
                    .filter((role) => getPharmacyRoleDisplay(pharm).displayedRoles.includes(role))
                    .map((role) =>
                        SrxApi.post('/removeuserrole', { entityID: pharm.pharmacyId, email, UserRole: role })
                            .then(() => true)
                            .catch(() => false)
                    )
            )
        ).then((results) => {
            const succeeded = results.filter(Boolean).length;
            const failed = results.length - succeeded;
            if (failed === 0) {
                toast.success('Role group removed from all pharmacies');
            } else {
                toast.error(`Role group removed, but ${failed} update${failed === 1 ? '' : 's'} failed`);
            }
        });
    }

    function applyRoleGroupToAllPharmacies(selection) {
        if (!selection) {
            removeRoleGroupFromAllPharmacies(savedPharmaciesRoleGroup);
            return;
        }

        const editablePharmacies = (userPharmacies || []).filter((pharm) => {
            const isRoleEditingDisabled =
                readOnly || !canEditRole(pharm.pharmacyId, getPharmacyRoleNames(pharm), 'roleChange');
            return !isRoleEditingDisabled;
        });

        if (!editablePharmacies.length) {
            toast.error('No pharmacies available to update');
            return;
        }

        setHasPerformedAction(true);
        setSavedPharmaciesRoleGroup(selection);

        editablePharmacies.forEach((pharm) => {
            const id = getPharmacyId(pharm);
            const pickedTemplate = selectedRoleTemplates[pharm.pharmacyId];
            const oldTemplateRoles = pickedTemplate ? pickedTemplate.userRoles || [] : pharm.templateRoles || [];
            const current = getPharmacyRoleDisplay(pharm).displayedRoles;
            const extraRoles = current.filter((r) => !oldTemplateRoles.includes(r));
            const newRoles = Array.from(new Set([...(selection.userRoles || []), ...extraRoles]));

            setSelectedRoleTemplates((prev) => ({ ...prev, [pharm.pharmacyId]: selection }));
            setPharmacyRoleOverrides((prev) => ({ ...prev, [id]: newRoles }));
        });

        Promise.all(
            editablePharmacies.map((pharm) =>
                SrxApi.post('/edituser', { entityID: pharm.pharmacyId, email, RoleTemplateId: selection.value })
                    .then(() => true)
                    .catch(() => false)
            )
        ).then((results) => {
            const succeeded = results.filter(Boolean).length;
            const failed = results.length - succeeded;
            if (failed === 0) {
                toast.success(`Role group applied to ${succeeded} pharmac${succeeded === 1 ? 'y' : 'ies'}`);
            } else {
                toast.error(`Role group applied to ${succeeded} of ${results.length} pharmacies, ${failed} failed`);
            }
        });
    }

    function getActiveRoleGroupRoles() {
        const templateRoles = savedPharmaciesRoleGroup?.userRoles || [];
        if (!templateRoles.length) return [];
        const editablePharmacies = getEditablePharmacies();
        if (!editablePharmacies.length) return [];
        return templateRoles.filter((role) =>
            editablePharmacies.every((pharm) => getPharmacyRoleDisplay(pharm).displayedRoles.includes(role))
        );
    }

    function getPharmacyRolesOutsideTemplate(pharm) {
        const activeRoleGroupRoles = getActiveRoleGroupRoles();
        return getPharmacyRoleDisplay(pharm).displayedRoles.filter((r) => !activeRoleGroupRoles.includes(r));
    }

    function getRolesOnAllPharmacies() {
        const [firstRoles, ...otherRoles] = getEditablePharmacies().map(getPharmacyRolesOutsideTemplate);
        return (firstRoles || []).filter((role) => otherRoles.every((roles) => roles.includes(role)));
    }

    function getEditablePharmacies() {
        return (userPharmacies || []).filter((pharm) => {
            const isRoleEditingDisabled =
                readOnly || !canEditRole(pharm.pharmacyId, getPharmacyRoleNames(pharm), 'roleChange');
            return !isRoleEditingDisabled;
        });
    }

    function onRolesForAllPharmaciesChange(_, { action, option, removedValue }) {
        if (action === 'select-option') applyRoleToAllPharmacies(option.value);
        if (action === 'remove-value') removeRoleFromAllPharmacies(removedValue.value);
    }

    function applyRoleToAllPharmacies(roleValue) {
        const editablePharmacies = getEditablePharmacies();

        if (!editablePharmacies.length) {
            toast.error('No pharmacies available to update');
            return;
        }

        setHasPerformedAction(true);

        editablePharmacies.forEach((pharm) => {
            const id = getPharmacyId(pharm);
            const { displayedRoles } = getPharmacyRoleDisplay(pharm);
            if (displayedRoles.includes(roleValue)) return;
            setPharmacyRoleOverrides((prev) => ({
                ...prev,
                [id]: [...(prev[id] ?? displayedRoles), roleValue],
            }));
        });

        Promise.all(
            editablePharmacies.map((pharm) => {
                const { currentTemplate } = getPharmacyRoleDisplay(pharm);
                return SrxApi.post('/edituser', {
                    entityID: pharm.pharmacyId,
                    email,
                    RoleTemplateId: currentTemplate?.value ?? null,
                    UserRole: roleValue,
                })
                    .then(() => true)
                    .catch(() => false);
            })
        ).then((results) => {
            const succeeded = results.filter(Boolean).length;
            const failed = results.length - succeeded;
            if (failed === 0) {
                toast.success(`Role applied to ${succeeded} pharmac${succeeded === 1 ? 'y' : 'ies'}`);
            } else {
                toast.error(`Role applied to ${succeeded} of ${results.length} pharmacies, ${failed} failed`);
            }
        });
    }

    function removeRoleFromAllPharmacies(roleValue) {
        const editablePharmacies = getEditablePharmacies().filter((pharm) =>
            getPharmacyRoleDisplay(pharm).displayedRoles.includes(roleValue)
        );

        if (!editablePharmacies.length) {
            toast.error('No pharmacies available to update');
            return;
        }

        setHasPerformedAction(true);

        editablePharmacies.forEach((pharm) => {
            const id = getPharmacyId(pharm);
            const { displayedRoles } = getPharmacyRoleDisplay(pharm);
            setPharmacyRoleOverrides((prev) => ({
                ...prev,
                [id]: (prev[id] ?? displayedRoles).filter((r) => r !== roleValue),
            }));
        });

        Promise.all(
            editablePharmacies.map((pharm) =>
                SrxApi.post('/removeuserrole', { entityID: pharm.pharmacyId, email, UserRole: roleValue })
                    .then(() => true)
                    .catch(() => false)
            )
        ).then((results) => {
            const succeeded = results.filter(Boolean).length;
            const failed = results.length - succeeded;
            if (failed === 0) {
                toast.success(`Role removed from ${succeeded} pharmac${succeeded === 1 ? 'y' : 'ies'}`);
            } else {
                toast.error(`Role removed from ${succeeded} of ${results.length} pharmacies, ${failed} failed`);
            }
        });
    }

    function onPharmUserRoleChange(roleValue, pharmacy, currentTemplate, forEmail) {
        return SrxApi.post('/edituser', {
            entityID: pharmacy.pharmacyId,
            email: forEmail,
            RoleTemplateId: currentTemplate?.value ?? null,
            UserRole: roleValue,
        })
            .then(() => toast.success('User role successfully changed'))
            .catch((err) => {
                toast.error('Error: ' + err.message);
                throw err;
            });
    }

    function removePharmUserRole(roleValue, pharmacy, forEmail) {
        return SrxApi.post('/removeuserrole', { entityID: pharmacy.pharmacyId, email: forEmail, UserRole: roleValue })
            .then(() => toast.success('Role removed'))
            .catch((err) => {
                toast.error(err.response?.data?.message || 'Error: ' + err.message);
                throw err;
            });
    }

    const addPharmacyRole = (pharmacy, currentTemplate, baseRoles, roleValue) => {
        const current = pharmacyRoleOverrides[pharmacy.pharmacyId] ?? baseRoles;
        if (current.includes(roleValue)) return;
        setHasPerformedAction(true);
        setPharmacyRoleOverrides((prev) => ({ ...prev, [pharmacy.pharmacyId]: [...current, roleValue] }));
        onPharmUserRoleChange(roleValue, pharmacy, currentTemplate, email).catch(() =>
            setPharmacyRoleOverrides((prev) => ({ ...prev, [pharmacy.pharmacyId]: current }))
        );
    };

    const removePharmacyRole = (pharmacy, baseRoles, roleValue) => {
        const current = pharmacyRoleOverrides[pharmacy.pharmacyId] ?? baseRoles;
        setHasPerformedAction(true);
        setPharmacyRoleOverrides((prev) => ({ ...prev, [pharmacy.pharmacyId]: current.filter((r) => r !== roleValue) }));

        const wasSelectedStandardRole = selectedStandardRole?.value === roleValue;
        if (wasSelectedStandardRole) setSelectedStandardRole(null);

        removePharmUserRole(roleValue, pharmacy, email).catch(() => {
            setPharmacyRoleOverrides((prev) => ({ ...prev, [pharmacy.pharmacyId]: current }));
            if (wasSelectedStandardRole) setSelectedStandardRole({ value: roleValue, label: roleValue });
        });
    };

    const getPharmacyId = (pharmacy) => pharmacy.pharmacyId ?? pharmacy.pharmID;

    const getPharmacyRoleNames = (pharm) => {
        const actualRoles = pharm.userRoles && pharm.userRoles.length ? pharm.userRoles : pharm.userRole ? [pharm.userRole] : [];
        const templateRoles = pharm.roleTemplate?.userRoles || pharm.templateRoles || [];
        return Array.from(new Set([...templateRoles, ...actualRoles]));
    };

    const getPharmacyRoleDisplay = (pharmacy) => {
        const id = getPharmacyId(pharmacy);
        const currentTemplate =
            selectedRoleTemplates[id] ||
            (pharmacy.roleTemplate
                ? {
                      value: pharmacy.roleTemplate.roleTemplateId,
                      label: pharmacy.roleTemplate.templateName,
                      userRoles: pharmacy.roleTemplate.userRoles || [],
                  }
                : null);
        const pickedTemplate = selectedRoleTemplates[id];
        const actualRoles = pharmacy.userRoles && pharmacy.userRoles.length ? pharmacy.userRoles : pharmacy.userRole ? [pharmacy.userRole] : [];
        const templateRoles = pickedTemplate ? pickedTemplate.userRoles || [] : pharmacy.templateRoles || [];
        const combinedRoles = Array.from(new Set([...templateRoles, ...actualRoles]));
        const displayedRoles = (pharmacyRoleOverrides[id] ?? combinedRoles).filter(
            (r) => r !== selectedStandardRole?.value
        );
        return { currentTemplate, displayedRoles };
    };

    useEffect(() => {
        const templateRoles = savedPharmaciesRoleGroup?.userRoles || [];
        if (!templateRoles.length || !userPharmacies?.length) return;
        const editablePharmacies = getEditablePharmacies();
        if (!editablePharmacies.length) return;
        const stillApplied = templateRoles.some((role) =>
            editablePharmacies.every((pharm) => getPharmacyRoleDisplay(pharm).displayedRoles.includes(role))
        );
        if (!stillApplied) setSavedPharmaciesRoleGroup(null);
    }, [savedPharmaciesRoleGroup, userPharmacies, pharmacyRoleOverrides, selectedRoleTemplates]);

    const addPendingPharmacyRole = (pharmacy, baseRoles, roleValue) => {
        const id = getPharmacyId(pharmacy);
        const current = pharmacyRoleOverrides[id] ?? baseRoles;
        if (current.includes(roleValue)) return;
        setHasPerformedAction(true);
        setPharmacyRoleOverrides((prev) => ({ ...prev, [id]: [...current, roleValue] }));
    };

    const removePendingPharmacyRole = (pharmacy, baseRoles, roleValue) => {
        const id = getPharmacyId(pharmacy);
        const current = pharmacyRoleOverrides[id] ?? baseRoles;
        setHasPerformedAction(true);
        setPharmacyRoleOverrides((prev) => ({ ...prev, [id]: current.filter((r) => r !== roleValue) }));
    };

    const assignStandardRole = (selection) => {
        const previousRoleValue = selectedStandardRole?.value;
        setSelectedStandardRole(selection);

        const roleValue = selection?.value ?? null;
        if (roleValue === previousRoleValue) return;

        setHasPerformedAction(true);

        (userPharmacies || []).forEach((pharm) => {
            const currentTemplate =
                selectedRoleTemplates[pharm.pharmacyId] ||
                (pharm.roleTemplate
                    ? { value: pharm.roleTemplate.roleTemplateId, label: pharm.roleTemplate.templateName, userRoles: pharm.roleTemplate.userRoles || [] }
                    : null);
            const actualRoles = pharm.userRoles && pharm.userRoles.length ? pharm.userRoles : pharm.userRole ? [pharm.userRole] : [];
            const pickedTemplate = selectedRoleTemplates[pharm.pharmacyId];
            const templateRoles = pickedTemplate ? pickedTemplate.userRoles || [] : pharm.templateRoles || [];
            const current =
                pharmacyRoleOverrides[pharm.pharmacyId] ??
                Array.from(new Set([...templateRoles, ...actualRoles, ...(pharm.standardRoles || [])]));

            const hadPrevious = !!previousRoleValue && current.includes(previousRoleValue);
            const alreadyHasNew = !!roleValue && current.includes(roleValue);
            if (!hadPrevious && (alreadyHasNew || !roleValue)) return;

            const updated = current.filter((r) => r !== previousRoleValue);
            if (roleValue && !alreadyHasNew) updated.push(roleValue);

            setPharmacyRoleOverrides((prev) => ({ ...prev, [pharm.pharmacyId]: updated }));

            const revert = () => setPharmacyRoleOverrides((prev) => ({ ...prev, [pharm.pharmacyId]: current }));

            (async () => {
                try {
                    if (hadPrevious) await removePharmUserRole(previousRoleValue, pharm, email);
                    if (roleValue && !alreadyHasNew) await onPharmUserRoleChange(roleValue, pharm, currentTemplate, email);
                } catch {
                    revert();
                }
            })();
        });
    };

    function addToPendingPharmacies() {
        let tempSelected = cloneDeep(selectedPharmacy[0]);
        delete tempSelected.userRole;
        delete tempSelected.userRoles;
        delete tempSelected.templateRoles;
        delete tempSelected.roleTemplate;
        delete tempSelected.standardRoles;
        setHasPerformedAction(true);
        setPendingUserPharmacies([...pendingUserPharmacies, tempSelected]);
        setSelectedPharmacy([]);
        if (pendingBulkTemplate) {
            setSelectedRoleTemplates((prev) => ({ ...prev, [tempSelected.pharmID]: pendingBulkTemplate }));
        }
    }

    function applyBulkTemplateToPending(selection) {
        setHasPerformedAction(true);
        setPendingBulkTemplate(selection);
        setSelectedRoleTemplates((prev) => {
            const next = { ...prev };
            pendingUserPharmacies.forEach((pharmacy) => {
                next[getPharmacyId(pharmacy)] = selection;
            });
            return next;
        });
    }

    function applyBulkRoleToPendingPharmacies(selection) {
        if (!selection) {
            setPendingBulkRole(null);
            return;
        }
        setHasPerformedAction(true);
        setPendingBulkRole(selection);
        pendingUserPharmacies.forEach((pharmacy) => {
            const id = getPharmacyId(pharmacy);
            const { displayedRoles } = getPharmacyRoleDisplay(pharmacy);
            if (displayedRoles.includes(selection.value)) return;
            setPharmacyRoleOverrides((prev) => ({
                ...prev,
                [id]: [...(prev[id] ?? displayedRoles), selection.value],
            }));
        });
    }

    function deletePendingPharmacy(id) {
        setHasPerformedAction(true);
        setPendingUserPharmacies(pendingUserPharmacies.filter(({ pharmID }) => pharmID !== id));
        setPharmacyRoleOverrides((prev) => {
            const next = { ...prev };
            delete next[id];
            return next;
        });
        setSelectedRoleTemplates((prev) => {
            const next = { ...prev };
            delete next[id];
            return next;
        });
    }

    function saveAdditionalPendingPharmacies(forEmail) {
        if (!pendingUserPharmacies.length) return Promise.resolve();

        const pharmaciesToSave = pendingUserPharmacies.map((pharmacy) => ({ pharmacy, ...getPharmacyRoleDisplay(pharmacy) }));

        if (pharmaciesToSave.some(({ displayedRoles }) => !displayedRoles.length)) {
            toast.error('All pending pharmacies must be assigned a role');
            return Promise.reject();
        }

        return SrxApi.post('/adduserpharmacies', {
            email: forEmail,
            entities: pharmaciesToSave.map(({ pharmacy, displayedRoles }) => ({ entityid: pharmacy.pharmID, userRole: displayedRoles[0] })),
            ...(isDeletedUser ? { isDeleted: false } : {}),
        })
            .then(() =>
                Promise.all(
                    pharmaciesToSave.map(({ pharmacy, currentTemplate, displayedRoles }) => {
                        const savedPharmacyRef = { pharmacyId: pharmacy.pharmID };
                        const followUps = [];
                        if (displayedRoles.length > 1) {
                            displayedRoles
                                .slice(1)
                                .forEach((roleValue) => followUps.push(onPharmUserRoleChange(roleValue, savedPharmacyRef, currentTemplate, forEmail)));
                        } else if (currentTemplate) {
                            followUps.push(onPharmRoleTemplateChange(currentTemplate.value, forEmail, savedPharmacyRef));
                        }
                        return Promise.all(followUps);
                    })
                )
            )
            .then(() => {
                loadUserPharmacies(forEmail);
                setPharmacyRoleOverrides((prev) => {
                    const next = { ...prev };
                    pendingUserPharmacies.forEach((pharmacy) => delete next[getPharmacyId(pharmacy)]);
                    return next;
                });
                setSelectedRoleTemplates((prev) => {
                    const next = { ...prev };
                    pendingUserPharmacies.forEach((pharmacy) => delete next[getPharmacyId(pharmacy)]);
                    return next;
                });
                setPendingUserPharmacies([]);
                setPendingBulkTemplate(null);
                toast.success('User added to pharmacies');
            });
    }

    async function removeUserFromSinglePharmacy(id, name) {
        if (
            !(await confirm(`Remove <i>${displayName || email}</i> from <i>${name}</i>?`, `Removing user from pharmacy`, 'Confirm', 'Cancel', 'primary', 'primary'))
        )
            return;

        SrxApi.post('/removepharmacy', { email, pharmID: id })
            .then(() => {
                setHasPerformedAction(true);

                const newPharmacies = userPharmacies.filter(({ pharmacyId }) => pharmacyId !== id);
                setUserPharmacies(newPharmacies);

                const tempUsers = [...users];
                const matchedTempUser = tempUsers.find((u) => u.email === email);
                if (matchedTempUser) matchedTempUser.numberPharmacies = newPharmacies.length;
                setUsers(tempUsers);

                toast.success((displayName || email) + ' removed from ' + name);
            })
            .catch((err) => toast.error('Error: ' + err.message));
    }

    function validateForm() {
        const newValidState = { ...validState };
        let valid = true;

        newValidState.displayName = !!displayName && displayName.length >= 4;

        const digits = phone.replace(/\D/g, '');
        newValidState.phone = digits.length === 0 || digits.length === 10;

        if (!isKnownUser) {
            newValidState.password = !!password;
            newValidState.confirmPasswordMatches = password === confirmPassword;
            newValidState.pharmacies = newUserPharmacies.length > 0;
            newValidState.pharmacyRoleOrTemplate = !!(newUserPharmacyRole || newUserTemplateRole);
        } else {
            newValidState.password = true;
            newValidState.confirmPasswordMatches = true;
            newValidState.pharmacies = true;
            newValidState.pharmacyRoleOrTemplate = true;
        }

        for (let key in newValidState) {
            if (newValidState[key] === false) valid = false;
        }

        setValidState(newValidState);
        return valid;
    }

    function handleSave() {
        if (!validateForm()) return;
        setSaving(true);

        if (!isKnownUser) {
            const payload = {
                displayName,
                email,
                phone: phone.replace(/\D/g, ''),
                title,
                password,
                confirmPassword,
                pharmID: newUserPharmacies.map((p) => p.value),
                UserRole: newUserPharmacyRole?.value || null,
                RoleTemplateId: newUserTemplateRole?.value || null,
                UserType: 'PharmacyUser',
            };

            SrxApi.post('/createpharmuser', payload)
                .then(() => {
                    getPharmacyUsers && getPharmacyUsers();
                    toast.success('Pharmacy user successfully created');
                    toggle();
                })
                .catch((err) => toast.error(err.response?.data?.message || 'An error occurred'))
                .finally(() => setSaving(false));
            return;
        }

        const finalizeDetailsAndPharmacies = () => {
            const detailsPromise = SrxApi.post('/edituserinfo', {
                displayName,
                phone: phone.replace(/\D/g, ''),
                title,
                UserRole: activeUser?.pharmRole?.[0]?.role,
                email,
                entityId: activeUser?.pharmRole?.[0]?.pharid,
            });

            detailsPromise
                .then(() => saveAdditionalPendingPharmacies(email))
                .then(() => {
                    getPharmacyUsers && getPharmacyUsers();
                    toast.success('User updated successfully');
                    toggle();
                })
                .catch((err) => err && toast.error(err.response?.data?.message || err.message))
                .finally(() => setSaving(false));
        };

        restoreDeletedUserIfNeeded()
            .then(finalizeDetailsAndPharmacies)
            .catch((err) => {
                toast.error(err.response?.data?.message || 'Error restoring user');
                setSaving(false);
            });
    }

    // A deleted user has to be restored before anything else can be saved for them - their email in
    // the DB still carries the delete suffix until then, so /adduserpharmacies etc. can't find them.
    function restoreDeletedUserIfNeeded() {
        if (!isDeletedUser) return Promise.resolve();

        return SrxApi.post('/undeleteuser', { email }).then(() => {
            // restored once - a retry after a later step fails must not try to restore again
            setIsDeletedUser(false);
            toast.success((displayName || email) + ' restored');
        });
    }

    function handleSavePendingPharmacies() {
        restoreDeletedUserIfNeeded()
            .then(() => saveAdditionalPendingPharmacies(email))
            .catch((err) => {
                if (err) toast.error(err.response?.data?.message || err.message);
            });
    }

    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            size="lg"
            style={{
                minWidth: '600px',
                maxWidth: 'max-content',
                width: '100%',
                ...(showDetailFields ? { minHeight: '500px' } : {}),
            }}
            className="modal-dialog-scrollable">
            <ModalHeader toggle={toggle} className="modal-colored-header bg-primary">
                {isUpdateMode ? (
                    <>
                        {readOnly ? 'View Pharmacies for' : 'Update User'} <i>"{user?.displayName || user?.email}"</i>
                        {user?.email === contextUser.email && <Badge color="dark" className="ml-1" style={{ fontSize: '14px' }}>Self</Badge>}
                    </>
                ) : (
                    'Add Pharmacy User'
                )}
            </ModalHeader>
            <ModalBody>
                {!isUpdateMode && (
                    <FormGroup>
                        <Label for="add-pharm-user-email">Email *</Label>
                        <Input
                            type="email"
                            id="add-pharm-user-email"
                            placeholder="Enter email to search or add a new user..."
                            value={email}
                            onChange={(e) => handleEmailChange(e.target.value)}
                        />
                        {lookupStatus === 'invalid-domain' && (
                            <small className="text-danger">Only srxltc.com email addresses are allowed.</small>
                        )}
                        {lookupStatus === 'loading' && <small className="text-muted">Looking up email...</small>}
                        {lookupStatus === 'found' && !isDeletedUser && (
                            <small className="text-success">Existing user found — details and pharmacies loaded below.</small>
                        )}
                        {lookupStatus === 'found' && isDeletedUser && (
                            <small className="text-warning">This user was previously deleted. Saving will restore them.</small>
                        )}
                        {lookupStatus === 'not-found' && (
                            <small className="text-muted">No existing user found — fill out the details below to create one.</small>
                        )}
                    </FormGroup>
                )}

                {showDetailFields && (
                    <>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label style={{ color: !validState.displayName ? '#fa5c7c' : '' }}>Display Name *</Label>
                                    <Input value={displayName} onChange={(e) => setDisplayName(e.target.value)} placeholder="Display name..." disabled={readOnly} />
                                    {!validState.displayName && <div className="invalid-text">Name must include a minimum of 4 characters</div>}
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label style={{ color: !validState.phone ? '#fa5c7c' : '' }}>Phone</Label>
                                    <MaskedInput
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)}
                                        mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                                        placeholder="(xxx) xxxx-xxxx"
                                        className={`form-control ${!validState.phone ? 'invalid' : ''}`}
                                        disabled={readOnly}
                                    />
                                    {!validState.phone && <div className="invalid-text">Invalid phone</div>}
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Title</Label>
                                    <Input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Title..." disabled={readOnly} />
                                </FormGroup>
                            </Col>
                        </Row>

                        {!isKnownUser && (
                            <Row>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label style={{ color: !validState.password ? '#fa5c7c' : '' }}>Password *</Label>
                                        <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password..." />
                                        {!validState.password && <div className="invalid-text">Please enter a password</div>}
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label style={{ color: !validState.confirmPasswordMatches ? '#fa5c7c' : '' }}>Confirm Password *</Label>
                                        <Input type="password" autoComplete="off" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder="Re-enter Password..." />
                                        {!validState.confirmPasswordMatches && <div className="invalid-text">Passwords do not match</div>}
                                    </FormGroup>
                                </Col>
                            </Row>
                        )}

                        <hr />

                        {!isKnownUser && (
                            <FormGroup>
                                <Label style={{ color: !validState.pharmacies ? '#fa5c7c' : '' }}>Pharmacies *</Label>
                                <Select
                                    isMulti
                                    className={`${!validState.pharmacies ? 'invalid-select' : 'react-select'}`}
                                    classNamePrefix="react-select"
                                    loadingMessage={() => 'Loading Pharmacies'}
                                    isLoading={!pharmacies}
                                    placeholder="Select Pharmacies..."
                                    onChange={(selection) => {
                                        setValidState((prev) => ({ ...prev, pharmacies: true }));
                                        setNewUserPharmacies(selection ? [...selection] : []);
                                    }}
                                    value={newUserPharmacies}
                                    isSearchable={false}
                                    options={pharmacies.map((pharm) => ({ value: pharm.pharmID, label: pharm.pharmID }))}
                                />
                                {!validState.pharmacies && <div className="invalid-text">Please select at least one pharmacy</div>}
                            </FormGroup>
                        )}

                        {!isKnownUser && (
                            <>
                                <FormGroup>
                                    <Label style={{ color: !validState.pharmacyRoleOrTemplate ? '#fa5c7c' : '' }}>Role Group</Label>
                                    <Select
                                        className="react-select"
                                        classNamePrefix="react-select"
                                        isLoading={!roleTemplates}
                                        placeholder="Select Role Group..."
                                        isClearable
                                        isSearchable={false}
                                        onChange={(selection) => {
                                            setValidState((prev) => ({ ...prev, pharmacyRoleOrTemplate: true }));
                                            setNewUserTemplateRole(selection || null);
                                            if (selection?.userRoles?.includes(newUserPharmacyRole?.value)) setNewUserPharmacyRole(null);
                                        }}
                                        value={newUserTemplateRole}
                                        options={roleTemplates}
                                    />
                                    {newUserTemplateRole?.userRoles?.length > 0 && (
                                        <RoleBadgeList
                                            roles={newUserTemplateRole.userRoles}
                                            idPrefix="add-pharm-user-role-badges"
                                        />
                                    )}
                                </FormGroup>
                                <FormGroup>
                                    <Label style={{ color: !validState.pharmacyRoleOrTemplate ? '#fa5c7c' : '' }}>Pharmacy Role</Label>
                                    <Select
                                        className={`${!validState.pharmacyRoleOrTemplate ? 'invalid-select' : 'react-select'}`}
                                        classNamePrefix="react-select"
                                        isSearchable={false}
                                        isClearable
                                        placeholder="Select Role..."
                                        onChange={(selection) => {
                                            setValidState((prev) => ({ ...prev, pharmacyRoleOrTemplate: true }));
                                            setNewUserPharmacyRole(selection || null);
                                        }}
                                        value={newUserPharmacyRole}
                                        options={(pharmacyUserRoles || []).filter((role) => !newUserTemplateRole?.userRoles?.includes(role.value))}
                                    />
                                    {!validState.pharmacyRoleOrTemplate && (
                                        <div className="invalid-text">Please select a Pharmacy Role or a Role Group</div>
                                    )}
                                </FormGroup>
                            </>
                        )}

                        {isKnownUser && canManageFacilities && (
                            <FormGroup>
                                <Label for="itemType">Select Pharmacy</Label>
                                <InputGroup>
                                    <Typeahead
                                        paginate
                                        maxResults={15}
                                        id="user-form-pharmacy-select"
                                        labelKey="pharmID"
                                        disabled={!userPharmacies}
                                        multiple={false}
                                        options={pharmacies
                                            .filter((pharm) => pharm.userPermissions?.['canAddPharmacyToUser'] === true)
                                            .filter(
                                                (pharm) =>
                                                    (userPharmacies || []).findIndex((up) => up.pharmacyId === pharm.pharmID) === -1 &&
                                                    pendingUserPharmacies.findIndex((up) => up.pharmID === pharm.pharmID) === -1
                                            )}
                                        selected={selectedPharmacy}
                                        onChange={(selected) => setSelectedPharmacy(selected)}
                                        placeholder="Select pharmacy..."
                                    />
                                    <InputGroupAddon addonType="append">
                                        <Button color="primary" onClick={addToPendingPharmacies} disabled={!selectedPharmacy.length}>
                                            Add
                                        </Button>
                                    </InputGroupAddon>
                                </InputGroup>
                            </FormGroup>
                        )}

                        {isKnownUser && (
                            <FormGroup>
                                <Label for="standard-role">Standard Role</Label>
                                <Select
                                    className="react-select"
                                    classNamePrefix="react-select"
                                    name="standard-role"
                                    isLoading={!standardUserRoles}
                                    isClearable
                                    isSearchable={false}
                                    isDisabled={
                                        readOnly ||
                                        !(userPharmacies || []).some((pharm) =>
                                            canEditRole(pharm.pharmacyId, getPharmacyRoleNames(pharm), 'roleChange')
                                        )
                                    }
                                    placeholder="Select Standard Role..."
                                    value={selectedStandardRole}
                                    onChange={assignStandardRole}
                                    options={(standardUserRoles || []).map((role) => ({ value: role.name, label: role.label || role.name }))}
                                />
                                {selectedStandardRole && (
                                    <Badge
                                        color="secondary"
                                        pill
                                        className="font-weight-normal mt-2 d-inline-flex align-items-center"
                                        onMouseEnter={() => setStandardRoleChipHovered(true)}
                                        onMouseLeave={() => setStandardRoleChipHovered(false)}>
                                        {selectedStandardRole.label}
                                        {!readOnly && standardRoleChipHovered && (
                                            <Icon icon={closeIcon} width="12" height="12" className="ml-1" style={{ cursor: 'pointer' }} onClick={() => assignStandardRole(null)} />
                                        )}
                                    </Badge>
                                )}
                            </FormGroup>
                        )}

                        {!!pendingUserPharmacies.length && (
                            <Card>
                                <CardBody className="p-2 m-2" style={{ border: '2px dashed #BDC6CA', borderRadius: '3px' }}>
                                    <h4 className="ml-1">Pending Pharmacies</h4>
                                    {isKnownUser && pendingUserPharmacies.length > 1 && (
                                        <div className="d-flex" style={{ gap: '16px' }}>
                                            <FormGroup className="ml-1 mr-1" style={{ flex: 1 }}>
                                                <Label>Role Template for all pending pharmacies</Label>
                                                <Select
                                                    className="react-select"
                                                    classNamePrefix="react-select"
                                                    hideSelectedOptions
                                                    isSearchable={false}
                                                    placeholder="Select template..."
                                                    onChange={applyBulkTemplateToPending}
                                                    value={pendingBulkTemplate}
                                                    options={roleTemplates}
                                                />
                                            </FormGroup>
                                            <FormGroup className="ml-1 mr-1" style={{ flex: 1 }}>
                                                <Label>Role for all pending pharmacies</Label>
                                                <Select
                                                    className="react-select"
                                                    classNamePrefix="react-select"
                                                    hideSelectedOptions
                                                    isSearchable={false}
                                                    isClearable
                                                    placeholder="Select role..."
                                                    onChange={applyBulkRoleToPendingPharmacies}
                                                    value={pendingBulkRole}
                                                    options={pharmacyUserRoles || []}
                                                />
                                            </FormGroup>
                                        </div>
                                    )}
                                    <Table className="mb-0">
                                        <thead>
                                            <tr>
                                                <th>Pharmacy ID</th>
                                                <th>Pharmacy Name</th>
                                                <th>Role</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody style={{ overflow: 'auto', whiteSpace: 'nowrap' }}>
                                            {pendingUserPharmacies
                                                .sort((a, b) => (a.pharmID > b.pharmID ? 1 : -1))
                                                .map((pharm, index) => {
                                                    const { currentTemplate, displayedRoles } = getPharmacyRoleDisplay(pharm);
                                                    return (
                                                        <tr key={index}>
                                                            <td style={{ verticalAlign: 'top', paddingTop: '10px' }}>{pharm.pharmID}</td>
                                                            <td style={{ verticalAlign: 'top', paddingTop: '10px' }}>{pharm.pharmName}</td>
                                                            <td style={{ verticalAlign: 'top', paddingTop: '10px', minWidth: '220px', whiteSpace: 'normal' }}>
                                                                <div style={{ width: '180px' }}>
                                                                    <Select
                                                                        className="react-select"
                                                                        classNamePrefix="react-select"
                                                                        hideSelectedOptions
                                                                        isSearchable={false}
                                                                        isLoading={!roleTemplates}
                                                                        placeholder="Select template..."
                                                                        onChange={(selection) => {
                                                                            setHasPerformedAction(true);
                                                                            setSelectedRoleTemplates((prev) => ({ ...prev, [pharm.pharmID]: selection }));
                                                                        }}
                                                                        value={currentTemplate}
                                                                        options={roleTemplates}
                                                                    />
                                                                </div>
                                                                <RoleBadgeList
                                                                    roles={displayedRoles}
                                                                    idPrefix={`user-form-pending-pharm-role-badges-${pharm.pharmID}`}
                                                                    label=""
                                                                    editable
                                                                    availableRoles={pharmacyUserRoles || []}
                                                                    onAddRole={(roleValue) => addPendingPharmacyRole(pharm, displayedRoles, roleValue)}
                                                                    onRemoveRole={(roleValue) => removePendingPharmacyRole(pharm, displayedRoles, roleValue)}
                                                                />
                                                            </td>
                                                            <td style={{ verticalAlign: 'top', paddingTop: '10px' }}>
                                                                <Button className="card-drop p-0 text-white" onClick={() => deletePendingPharmacy(pharm.pharmID)}>
                                                                    <Icon icon={deleteIcon} height="24" width="24" />
                                                                </Button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                        </tbody>
                                    </Table>
                                    <hr />
                                    <div className="d-flex justify-content-end">
                                        <Button
                                            color="primary"
                                            disabled={pendingUserPharmacies.some((p) => !getPharmacyRoleDisplay(p).displayedRoles.length)}
                                            onClick={handleSavePendingPharmacies}>
                                            Save Pending Pharmacies
                                        </Button>
                                    </div>
                                </CardBody>
                            </Card>
                        )}

                        {isKnownUser && (
                            <>
                                <h4 className="ml-1">Pharmacies{userPharmacies?.length ? ` (${userPharmacies.length})` : ''}</h4>
                                {!readOnly && userPharmacies?.length > 1 && (() => {
                                    const isBulkRoleEditingDisabled =
                                        readOnly ||
                                        !(userPharmacies || []).some((pharm) =>
                                            canEditRole(pharm.pharmacyId, getPharmacyRoleNames(pharm), 'roleChange')
                                        );
                                    return (
                                    <div className="d-flex" style={{ gap: '16px' }}>
                                        <FormGroup className="ml-1 mr-1" style={{ flex: 1 }}>
                                            <Label>Role Group (applies to all pharmacies)</Label>
                                            <Select
                                                className="react-select"
                                                classNamePrefix="react-select"
                                                hideSelectedOptions
                                                isSearchable={false}
                                                isClearable
                                                isDisabled={isBulkRoleEditingDisabled}
                                                placeholder="Select role group..."
                                                onChange={applyRoleGroupToAllPharmacies}
                                                value={savedPharmaciesRoleGroup}
                                                options={roleTemplates}
                                            />
                                            <RoleBadgeList
                                                roles={getActiveRoleGroupRoles()}
                                                idPrefix="saved-pharmacies-role-group-badges"
                                                label=""
                                                maxVisible={4}
                                                editable={!isBulkRoleEditingDisabled}
                                                allowAdd={false}
                                                onRemoveRole={removeRoleFromAllPharmacies}
                                            />
                                        </FormGroup>
                                        <FormGroup className="ml-1 mr-1" style={{ flex: 1 }}>
                                            <Label>Role (applies to all pharmacies)</Label>
                                            <Select
                                                className="react-select"
                                                classNamePrefix="react-select"
                                                isMulti
                                                hideSelectedOptions
                                                isSearchable={false}
                                                isClearable={false}
                                                backspaceRemovesValue={false}
                                                isDisabled={isBulkRoleEditingDisabled}
                                                placeholder="Select role..."
                                                components={{ ValueContainer: PharmacyRoleValueContainer }}
                                                onChange={onRolesForAllPharmaciesChange}
                                                value={getRolesOnAllPharmacies().map(
                                                    (role) => pharmacyUserRoles?.find((r) => r.value === role) ?? { value: role, label: role }
                                                )}
                                                options={(pharmacyUserRoles || []).filter(
                                                    (option) => !getActiveRoleGroupRoles().includes(option.value)
                                                )}
                                            />
                                        </FormGroup>
                                    </div>
                                    );
                                })()}
                                {userPharmacies ? (
                                    <div
                                        style={{
                                            maxHeight: '320px',
                                            overflowY: 'auto',
                                            border: '1px solid #e9ecef',
                                            borderRadius: '4px',
                                        }}>
                                    <Table className="mb-0" size="sm">
                                        <thead>
                                            <tr>
                                                <th>Pharmacy ID</th>
                                                <th>Pharmacy Name</th>
                                                <th>Role</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody style={{ overflow: 'auto', whiteSpace: 'nowrap' }}>
                                            {userPharmacies.length > 0 ? (
                                                userPharmacies
                                                    .sort((a, b) => (a.pharmacyId > b.pharmacyId ? 1 : -1))
                                                    .map((pharm, index) => {
                                                        const currentTemplate =
                                                            selectedRoleTemplates[pharm.pharmacyId] ||
                                                            (pharm.roleTemplate
                                                                ? {
                                                                      value: pharm.roleTemplate.roleTemplateId,
                                                                      label: pharm.roleTemplate.templateName,
                                                                      userRoles: pharm.roleTemplate.userRoles || [],
                                                                  }
                                                                : null);
                                                        const actualRoles = pharm.userRoles && pharm.userRoles.length ? pharm.userRoles : pharm.userRole ? [pharm.userRole] : [];
                                                        const pickedTemplate = selectedRoleTemplates[pharm.pharmacyId];
                                                        const templateRoles = pickedTemplate ? pickedTemplate.userRoles || [] : pharm.templateRoles || [];
                                                        const combinedRoles = Array.from(new Set([...templateRoles, ...actualRoles]));
                                                        const displayedRoles = (pharmacyRoleOverrides[pharm.pharmacyId] ?? combinedRoles).filter(
                                                            (r) => r !== selectedStandardRole?.value
                                                        );
                                                        const isRoleEditingDisabled = readOnly || !canEditRole(
                                                            pharm.pharmacyId,
                                                            getPharmacyRoleNames(pharm),
                                                            'roleChange'
                                                        );
                                                        return (
                                                            <tr key={index}>
                                                                <td style={{ verticalAlign: 'top', paddingTop: '10px' }}>{pharm.pharmacyId}</td>
                                                                <td style={{ verticalAlign: 'top', paddingTop: '10px' }}>{pharm.pharmName}</td>
                                                                <td style={{ verticalAlign: 'top', paddingTop: '10px' }}>
                                                                    <div style={{ width: '180px' }}>
                                                                        <Select
                                                                            className="react-select"
                                                                            classNamePrefix="react-select"
                                                                            hideSelectedOptions
                                                                            isSearchable={false}
                                                                            isLoading={!roleTemplates}
                                                                            placeholder="Select template..."
                                                                            isDisabled={isRoleEditingDisabled}
                                                                            onChange={(selection) => {
                                                                                setHasPerformedAction(true);
                                                                                setSelectedRoleTemplates((prev) => ({ ...prev, [pharm.pharmacyId]: selection }));
                                                                                onPharmRoleTemplateChange(selection.value, email, pharm);
                                                                            }}
                                                                            value={currentTemplate}
                                                                            options={roleTemplates}
                                                                        />
                                                                    </div>
                                                                    <RoleBadgeList
                                                                        roles={displayedRoles}
                                                                        idPrefix={`user-form-pharm-role-badges-${pharm.pharmacyId}`}
                                                                        label=""
                                                                        editable={!isRoleEditingDisabled}
                                                                        availableRoles={pharmacyUserRoles || []}
                                                                        onAddRole={(roleValue) => addPharmacyRole(pharm, currentTemplate, displayedRoles, roleValue)}
                                                                        onRemoveRole={(roleValue) => removePharmacyRole(pharm, displayedRoles, roleValue)}
                                                                    />
                                                                </td>
                                                                <td style={{ verticalAlign: 'top', paddingTop: '10px' }}>
                                                                    <Button
                                                                        color="link"
                                                                        className="card-drop p-0 text-muted"
                                                                        disabled={
                                                                            readOnly ||
                                                                            !canEditRole(pharm.pharmacyId, getPharmacyRoleNames(pharm), 'delete')
                                                                        }
                                                                        onClick={() => removeUserFromSinglePharmacy(pharm.pharmacyId, pharm.pharmName)}>
                                                                        <Icon icon={deleteIcon} height="20" width="20" />
                                                                    </Button>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                            ) : (
                                                <tr>
                                                    <td colSpan={4} className="text-center">
                                                        <b>No User Pharmacies</b>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                    </div>
                                ) : (
                                    <div className="w-100 d-flex justify-content-center">
                                        <div>
                                            <h4>Loading User Pharmacies...</h4>
                                            <div className="bouncing-loader">
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                    </>
                )}
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>
                    {readOnly ? 'Close' : 'Cancel'}
                </Button>
                {showDetailFields && !readOnly && (
                    <Button
                        color="primary"
                        disabled={saving || (isDetailsUnchanged && !pendingUserPharmacies.length && !hasPerformedAction)}
                        onClick={handleSave}>
                        Save
                    </Button>
                )}
            </ModalFooter>
        </Modal>
    );
};

export default PharmacyUsers;
